'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { MapPin, Search } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import useClickOutside from '../../hooks/useClickOutside';
import { type PhotonSearchResult, PhotonSearchService } from '../../services/photonSearch';
interface SearchDropdownProps {
  query: string;
  onResultClick: (result: PhotonSearchResult) => void;
}
export default function SearchDropdown(t0) {
  const $ = _c(23);
  const {
    query,
    onResultClick
  } = t0;
  const dropdownRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsVisible(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useClickOutside(dropdownRef, t1);
  const [debouncedQuery, setDebouncedQuery] = useState(query);
  let t2;
  let t3;
  if ($[1] !== query) {
    t2 = () => {
      const handler = setTimeout(() => setDebouncedQuery(query), 300);
      return () => clearTimeout(handler);
    };
    t3 = [query];
    $[1] = query;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] !== debouncedQuery) {
    t4 = ["search", debouncedQuery];
    t5 = () => {
      setIsVisible(true);
      return PhotonSearchService.search(debouncedQuery);
    };
    $[4] = debouncedQuery;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== debouncedQuery) {
    t6 = debouncedQuery.trim();
    $[7] = debouncedQuery;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = Boolean(t6);
  let t8;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t7) {
    t8 = {
      queryKey: t4,
      queryFn: t5,
      enabled: t7
    };
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const {
    data: t9,
    isLoading
  } = useQuery(t8);
  let t10;
  if ($[13] !== t9) {
    t10 = t9 === undefined ? [] : t9;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const data = t10;
  let t11;
  if ($[15] !== onResultClick) {
    t11 = result => {
      onResultClick(result);
      setIsVisible(false);
    };
    $[15] = onResultClick;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const handleResultClick = t11;
  if (!isVisible || !isLoading && data.length === 0 && !query.trim()) {
    return null;
  }
  let t12;
  if ($[17] !== data || $[18] !== handleResultClick || $[19] !== isLoading) {
    t12 = isLoading ? <div className="flex items-center gap-2 p-4 text-textSecondary"><Search className="size-4 animate-spin" /><span>Searching...</span></div> : data.length === 0 ? null : <div className="py-1">{data.map(result_0 => <div key={`${result_0.properties.osm_id}-${result_0.properties.osm_type}`} className="flex cursor-pointer items-center gap-3 px-4 py-3 transition-colors hover:bg-background-light bg-background-secondary" onClick={() => handleResultClick(result_0)}><MapPin className="size-4 text-textSecondary" /><div className="flex-1"><div className="font-emphasis text-textPrimary">{result_0.properties.name}</div><div className="text-sm text-textSecondary">{PhotonSearchService.formatSearchResult(result_0)}</div><div className="text-xs text-textSecondary">{result_0.properties.type} •{" "}{result_0.properties.countrycode.toUpperCase()}</div></div></div>)}</div>;
    $[17] = data;
    $[18] = handleResultClick;
    $[19] = isLoading;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <div ref={dropdownRef} className="absolute inset-x-0 top-full z-50 mt-1 max-h-80 overflow-y-auto rounded-lg border border-ds-border-standard bg-background-primary shadow-lg">{t12}</div>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}